import { ReactNode } from 'react';

import { useEmotionCards } from '@/hooks/emotion-detector';

import { CarouselContainer, CarouselWrapper } from './styles';

interface EmotionCardCarouselProps {
	cardState: ReturnType<typeof useEmotionCards>;
	children: ReactNode;
}

export default function EmotionCardCarousel({ cardState, children }: EmotionCardCarouselProps) {
	const { isDragging, handleMouseDown, handleMouseLeave, handleMouseUp, handleMouseMove } = cardState;

	return (
		<CarouselWrapper>
			<CarouselContainer
				data-carousel="container"
				isDragging={isDragging}
				onMouseDown={handleMouseDown}
				onMouseLeave={handleMouseLeave}
				onMouseUp={handleMouseUp}
				onMouseMove={handleMouseMove}
			>
				{children}
			</CarouselContainer>
		</CarouselWrapper>
	);
}
